import type { NotificationEvent } from "../../types/Notification";

// sessionStorage key holding the "dismissed-through" watermark: the timestamp
// of the newest event at the moment the user dismissed the feed island. The
// island stays hidden until a notification NEWER than this arrives — so the
// dismiss survives reopen, navigation/remount, and other UserControls
// instances, yet still reappears for genuinely new notifications.
export const NOTIF_DISMISS_KEY = "mblab.notif.dismissedThrough";

// Pure: should the feed island be shown? True when there's at least one event
// strictly newer than the dismiss watermark. No watermark → show whenever the
// feed is non-empty. Empty feed → never show.
export const feedHasNewSince = (
  events: NotificationEvent[],
  dismissedThrough: string | null,
): boolean => {
  if (events.length === 0) return false;
  if (!dismissedThrough) return true;
  const cutoff = new Date(dismissedThrough).getTime();
  return events.some((e) => new Date(e.at).getTime() > cutoff);
};
